import { Stack, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import PopupButton from "../common/PopupButton";
import PopupModelWrapper from "../wrappers/PopupModelWrapper";
import useData from "src/hooks/useApi";
import useMessage from "src/hooks/useMessage";

type PreBidDelete = {
    open: boolean;
    bidId: number;
    domainName: string;
    setOpen: Dispatch<SetStateAction<boolean>>;
    clearSelectedBid: () => void;
    setReloadData: React.Dispatch<React.SetStateAction<number>>;
};

const DeletePreBidModel = (props: PreBidDelete) => {
    const {
        open,
        bidId,
        domainName,
        setOpen,
        clearSelectedBid,
        setReloadData,
    } = props;

    const { postData } = useData();
    const { showError, showSuccess } = useMessage();

    const handleClose = () => {
        clearSelectedBid();
        setOpen(false);
    };

    async function handleDelete() {
        try {
            const response: any = await postData("/bid/deleteUserBid", {
                bidId: bidId,
            });
            if (response?.success) {
                showSuccess(`The Bid for ${domainName} successfully deleted`);
            } else {
                throw new Error("Deletion Failed");
            }
        } catch (error) {
            showError(`The Bid delete for ${domainName} failed`);
        } finally {
            handleClose();
            setReloadData(Date.now() / 1000);
        }
    }

    return (
        <PopupModelWrapper
            handleClose={handleClose}
            open={open}
            title="Delete Bid"
        >
            <Stack sx={{ my: 3 }}>
                <Typography
                    sx={{
                        color: "#3A3541CC",
                        fontWeight: 500,
                        fontSize: "18px",
                        pt: 1,
                    }}
                >
                    Are you sure you want to{" "}
                    <span style={{ color: "#FF5D5F" }}>Delete</span> the bid for{" "}
                    {domainName} ?
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        pb: 1,
                        color: "#3A354180",
                    }}
                >
                    This action cannot be undone
                </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-end">
                <PopupButton
                    triggerFunction={() => {
                        setOpen(false);
                    }}
                    type="cancel"
                >
                    Cancel
                </PopupButton>
                <PopupButton
                    triggerFunction={() => {
                        handleDelete();
                        setOpen(false);
                    }}
                    type="proceed"
                >
                    Proceed
                </PopupButton>
            </Stack>
        </PopupModelWrapper>
    );
};

export default DeletePreBidModel;
